import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { X, ShoppingBag, } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum } from '../common/function';
import { changeAlramModal, checkDuplicateLogins, checkSecuretId } from '../../store';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useActionState } from 'react';

function WalletDisabled() {
    const { t } = useTranslation();
    
    return (
        <div
            className="friend"
            style={{
                background: "#fff",
                padding: "20px",
                position: "relative"
            }}
        >
            <div style={{ width: "100%", height: "90%", color: "#000", fontSize: "20px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {t('message_9')}
            </div>
        </div >
    );
}

export default WalletDisabled;